import { createFileRoute } from "@tanstack/react-router";
import ProductHub from "@/pages/ProductHub";
import { hubArticlesQueryOptions } from "@/lib/hubArticles";

export const Route = createFileRoute("/chainsaws/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(hubArticlesQueryOptions("chainsaws")).catch(() => null);
  },
  component: () => <ProductHub hubSlug="chainsaws" />,
});
